var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5003L15 13.5003M21.9999 6.50022L12.9688 15.5314C12.1403 16.3598 10.7972 16.3598 9.96875 15.5314C9.14032 14.703 9.14032 13.3598 9.96875 12.5314L18.9999 3.50022C19.8283 2.67182 21.1714 2.6718 21.9999 3.50017C22.8284 4.32859 22.8284 5.67177 21.9999 6.50022ZM10.8398 17.7503C10.8398 19.5452 9.38477 21.0003 7.58984 21.0003H3L3.2103 20.8951C4.24629 20.3771 4.76276 19.1917 4.43667 18.0803C4.37245 17.8614 4.33395 17.6338 4.35777 17.4069C4.52929 15.7734 5.91089 14.5003 7.58984 14.5003C9.38477 14.5003 10.8398 15.9554 10.8398 17.7503Z",
    stroke: "#179EF8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBrush);
export default __webpack_public_path__ + "static/media/blue-brush.306e9299e645f8d093512293342cc07d.svg";
export { ForwardRef as ReactComponent };